import { resolveIconUrl } from '../../../../utils/resolveIconUrl';
import { resolveImageUrl } from '../../../../utils/resolveImageUrl';

import { deviceSize } from '../../../../style/responsive.styled';

const modal = {
  backdrop: 'rgba(0,0,0,0.33)',
  background: '#ffffff',
  height_desktop: '800px',
  width_desktop: '1200px',
  additional_css: '',
};

const close_btn = {
  mobile: {
    bg_size: '22px',
    bg_color: 'rgba(0, 0, 0, 0.47)',
    icon_size: '7.86px',
    icon_color: '#ffffff',
  },
  desktop: {
    icon_size: '18px',
    icon_color: '#000000',
  },
  additional_css: '',
};

const hero_image = {
  url: resolveImageUrl('tour/tour_main_image_v3.png'),
  height: '200px',
  width: '100%',
  tablet: { height: '250px', order: '1' },
  additional_css: '',
};

const gallery_text_box = {
  color: '#AAAAAA',
  sticky_background: 'rgba(0,0,0,0.7)',
  sticky_color: '#ffffff',
  tablet: {
    color: '#ffffff',
    background: '#272727',
    sticky_color: '#ffffff',
  },
  additional_css: '',
};

const cta_button = {
  color: '#FFFFFF',
  background: '#272727',
  camera_icon_url: resolveIconUrl('camera-search.svg'),
  camera_icon_size: '26px',
  gallery_icon_url: resolveIconUrl('gallery-search.svg'),
  gallery_icon_size: '26px',
  width: 'fit-content',
  height: '48px',
  additional_css: `
    justify-content: flex-start;
    text-align: center;
    padding-left: 1em;
    padding-right: 1em;
    span {
      margin-inline-start: 5px;
      width: calc(100% - 1em);
    }
  `,
  additional_mq: {
    [deviceSize.mobileL]:
      'span { margin-inline-start: 1em; } padding-left: 1em; padding-right: 1em;',
  },
};

const info_link = {
  textDecorationLine: 'underline',
  additional_css: '',
};

const MinimalTourTheme = {
  font_family: 'inherit',
  modal,
  close_btn,
  hero_image,
  gallery_text_box,
  cta_button,
  info_link,
  additional_css: '',
};

export default MinimalTourTheme;
